/**
 * Create the store with asynchronously loaded reducers
 */

import { configureStore } from '@reduxjs/toolkit'
import { mailboxSlice } from 'features/messaging'
import { notificationSlice } from 'features/notifications'

import { apiRTK } from '../api/api-rtk'
import { automationApi } from '../api/automationApi'
import activity from './reducers/activity'
import { appSlice } from './reducers/app'
import campaign from './reducers/campaign'
import { campaignCreateSlice } from './reducers/campaignCreate'
import { campaignsSlice } from './reducers/campaigns'
import contacts from './reducers/contacts'
import filters from './reducers/filters'
import home from './reducers/home'
import { leftSideSlice } from './reducers/leftSideMenu'
import campaignsTeams from './reducers/teams'

const store = configureStore({
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({
			// ! Store data like this in not Redux way. Better to refactor
			immutableCheck: false,
			serializableCheck: false
			// serializableCheck: {
			//   ignoredActions: [appSlice.actions.createConnector.type],
			//   ignoredPaths: ["app.connector"],
			// },
		}).concat([automationApi.middleware, apiRTK.middleware]),

	reducer: {
		activity,
		[apiRTK.reducerPath]: apiRTK.reducer,
		[appSlice.name]: appSlice.reducer,
		[automationApi.reducerPath]: automationApi.reducer,
		campaign,
		[campaignCreateSlice.name]: campaignCreateSlice.reducer,
		[campaignsSlice.name]: campaignsSlice.reducer,
		campaignsTeams,
		contacts,
		filters,
		home,
		[leftSideSlice.name]: leftSideSlice.reducer,
		[mailboxSlice.reducerPath]: mailboxSlice.reducer,
		[notificationSlice.name]: notificationSlice.reducer
	}
})

type AppDispatch = typeof store.dispatch
type RootState = ReturnType<typeof store.getState>

export type { AppDispatch, RootState }

export default store
